export default interface DepartmentSapParameter {
    groupId: number;
    fieldName: string;
    valueType: string;
    value: string;
}

export const departmentSapParameterRequiredFileds: string[] = [ 
    'PurchaseDocumentType',
    'PurchasingGroup',
    'PurchasingOrganization',
    'OrderNumber',
    'GLAccount'
]
const productTypeAllowedFields: string[] = [
    'OrderNumber',
    'GLAccount'
]
export const productTypeFields: string[] = [
    "Code",
    "Description",
    "OrderNumber"
]
export const customerFields: string[] = [
    "VendorCode",
    "Description",
    "PayerOfAccountCode",
    "OrderNumber"
]
export function validateDepartmentSapParameters(departmentSapParameter: DepartmentSapParameter[] | undefined): Map<string, string> | undefined {
    const errors = new Map<string, string>();

    if (!departmentSapParameter) {
        departmentSapParameter = [];
    }

    for(const field of departmentSapParameterRequiredFileds) {
        const item = departmentSapParameter.find(m => m.fieldName === field);
        if (!item || !item.value || item.value.length === 0) {
            errors.set(field, "Value field is required.");
            continue;
        }
        if (item.valueType === "ProductType" && !productTypeAllowedFields.includes(item.value)) {
            errors.set(field, `Product type is not allowed for field ${item.fieldName}`);
            continue;
        }
        switch(item.valueType) {
            case "Fixed":
                break;
            case "ProductType":
                if (!productTypeFields.includes(item.value)) {
                    errors.set(field, `Value ${item.value} is not valid for type ${item.valueType}`);
                }
                break;
            case "Customer":
                if (!customerFields.includes(item.value)) {
                    errors.set(field, `Value ${item.value} is not valid for type ${item.valueType}`);
                }
                break;
            default:
                errors.set(field, "Invalid type");
                break;
        }
    }

    if (errors.size > 0) {
        return errors;
    } else {
        return undefined;
    }
}